"use client";

import type { FC, Ref } from "react";
import { LinkCard, type LinkCardProps } from "@huub-web/ui/components/LinkCard";

type LinkCardTemplatePropsType = Pick<
  LinkCardProps,
  "src" | "url" | "title" | "description" | "subtitle"
>;

export interface LinkCardTemplateProps extends LinkCardTemplatePropsType {}

export const LinkCardTemplate: FC<
  LinkCardTemplateProps & { ref?: Ref<HTMLAnchorElement> }
> = ({ ref, ...props }) => <LinkCard ref={ref} {...props} />;
